<template>
  <div></div>
</template>
<script>
import protoComponent from './proto'
import { wgs2gcj, gcj2wgs } from '@/util/map/proj'

export default {
  name: 'SlAmapStartendMarker',
  extends: protoComponent,
  data() {
    return {
      startMarker: null,
      endMarker: null,
      SimpleMarkerTem: null,
    }
  },

  props: {
    center: {
      type: Array,
      class: 'latlng'
    },
    cs: {
      type: String,
      default: 'gcj02'
    },
    show: {
      type: Boolean,
      default: false
    },
  },
  created() {},
  methods: {
    $initComponent(options) {

    },
    $setCenter(v) {

    },
    $convCenter(v) {
      if (v) {
        return new AMap.LngLat(...(this.cs == 'wgs84' ? wgs2gcj(...v) : v))
      } else {
        return undefined
      }
    },
    _startMarker(data, iconOption, type) {
      if (this.startMarker) {
        let LngLatObj = new AMap.LngLat(...wgs2gcj(...data))
        this.startMarker.moveTo(LngLatObj, 20)
      } else {
        this.getStartEndSimpleMarker(data, iconOption, type)
      }
    },
    _endMarker(data, iconOption, type) {
      if (this.endMarker) {
        let LngLatObj = new AMap.LngLat(...wgs2gcj(...data))
        this.endMarker.moveTo(LngLatObj, 20)
      } else {
        this.getStartEndSimpleMarker(data, iconOption, type)
      }
    },
    clearStartEndMarker() {
      let map = this.$amap
      if (this.startMarker) {
        // 移除已创建的 marker
        map.remove(this.startMarker)
        this.startMarker = null
      }
      if (this.endMarker) {
        // 移除已创建的 marker
        map.remove(this.endMarker)
        this.endMarker = null
      }
    },
    getStartEndSimpleMarker(data, iconOption, type) {
      let _this = this
      let map = this.$amap
      if (!data[0]) {
        return
      }
      let option = {
        position: wgs2gcj(...data),
        map: map
      }


      if (iconOption) {
        option = {
          position: wgs2gcj(...data),
          map: map,
          ...iconOption
        }
      }
      AMapUI.loadUI(['overlay/SimpleMarker'], (SimpleMarker) => {
        if (String(type) === '1') {
          _this.endMarker = new SimpleMarker(option);
        } else {
          _this.startMarker = new SimpleMarker(option);
        }
        map.setFitView()
      })
    },
    /**
    自动适配到合适视野范围
    */
    setFitView() {
      let map = this.$amap
      // 自动适配到合适视野范围
      // 无参数，默认包括所有覆盖物的情况
      map.setFitView();
    },
  },
  destroyed() {

  },
  beforeDestroy() {

  }
};

</script>
<style>
.amap-marker-label {
  border: 0;
  background-color: transparent;
}

</style>
